var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('Header'),_c('div',{staticClass:"content",class:{'gray': _vm.setcolor}},[_c('router-view',{on:{"set_color":_vm.setColor}})],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }